import {t} from "@/core/i18n";


const API_URL = "/v1.0/management/Users";


const NAME = "allUsers";

const settings: AppContainerSettings = {
    hasView: true,
    hasExport: true,
    hasBlock: true,
    hasDelete: false,
    hasNotify: false,
    hasFilter: true,
    hasSearch: true,
    hasEdit: false,
    rowsOptions: {
        hasView: true,
        hasBlock: true,
        hasDelete: false,
        hasEdit: true,
        isCenter: false,
    } as RowsOptions
}

export const allowedSortBy = ["Id", "DisplayName", "IsEnabled", "Email", "CreatedAt", "PhoneNumber"];

const tableHeader: LabelVal[] = [
    {
        label: 'id',
        value: 'id',
    },
    {
        label: t('name'),
        value: 'name',
    },
    {
        label: t('grade'),
        value: 'Grade',
    },
    {
        label: t('school'),
        value: 'School',
    },
    {
        label: t('account'),
        value: 'Account',
    },
    {
        label: t('type'),
        value: 'Type',
    },
    {
        label: t('created-on'),
        value: 'created_on',
    },
    {
        label: t('city'),
        value: 'City',
    },
    {
        label: t('isActive'),
        value: 'isActive',
    },
    {
        label: t('action'),
        value: 'Action',
    }
]


export default {
    API_URL,
    settings,
    tableHeader,
    NAME
}
